import { defineStore } from "pinia";
import { computed, ref, Ref } from "vue";
import { DTOTierPrice } from "vue-app/api/dto";

export enum Customers {
  All = "all",
  Recommended = "recommended",
  Manual = "manual",
}

export const useFreemiumStore = defineStore("freemium", () => {
  const loaded = ref<boolean>(false);
  const customersCount = ref<number>(0);
  const recommendedCustomersCount = ref<number>(0);
  const daysToReset = ref<number>(0);
  const usedMessageCredits = ref<number>(0);
  const limitMessageCredits = ref<number>(0);
  const paying = ref(window.EDRONE_CONTEXT.tracker.isPaying);
  const priceTiers: Ref<DTOTierPrice[]> = ref([]);
  const selectedContacts = ref<number>(0);
  const selectedCustomersOption = ref<Customers>(Customers.Recommended);
  const freemiumLimitReached = computed(() => {
    return !paying.value && loaded.value && usedMessageCredits.value <= 0;
  });

  const getPlan = (value: number) => {
    return priceTiers.value.find((tier) => {
      return (
        (tier.fromUnits === null || tier.fromUnits <= value) && (tier.upToUnits === null || tier.upToUnits >= value)
      );
    });
  };

  return {
    customersCount,
    recommendedCustomersCount,
    daysToReset,
    usedMessageCredits,
    limitMessageCredits,
    paying,
    priceTiers,
    selectedContacts,
    selectedCustomersOption,
    getPlan,
    freemiumLimitReached,
    loaded,
  };
});
